export default __webpack_public_path__ + "static/media/FrictionTable2Img.90ec3a52.jpg";